import { gql, useMutation } from '@apollo/client';

export const MARK_ACTION_LOGS_AS_SEEN = gql`
  mutation MarkActionLogsAsSeen($limit: Int) {
    markActionLogsAsSeen(limit: $limit)
  }
`;

export function useMarkActionLogsAsSeenMutation() {
  return useMutation<{ markActionLogsAsSeen: number }>(MARK_ACTION_LOGS_AS_SEEN);
}
